import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
import {Actions as CREATEACCOUNTACTIONS} from '../store/actions/createAccountActions';


import { CheckIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import testimonialPhoto from '../assets/images/figolli/Chris-Deeson.webp';
import testimonialPhoto2 from '../assets/images/figolli/rod-figolla.jpeg';

import budgetTeamPhoto from '../assets/images/about/team/budget-team-photo.jpeg';
import gamesNightPhoto from '../assets/images/about/team/games-night-photo.jpeg';
import keelanSleepingPhoto from '../assets/images/about/team/keelan-sleeping.jpeg';
import planeTeamSelfie from '../assets/images/about/team/plane-selfie-1.jpeg';
import sicilyLunchPhoto from '../assets/images/about/team/team-lunch-sicily.jpeg';
import sicilyOutdoorsPhoto from '../assets/images/about/team/team-photo-outoors-sicily.jpeg';
import teamDevelopers from '../assets/images/about/team/team-developers.png';
import SeoHeaders from "../components/SeoHeaders";

// founding timeline


const timeline = [
  {
    name: 'Founded',
    description:
      'Buddy was founded to solve real payroll challenges faced by businesses and payroll professionals - removing unnecessary friction while increasing accuracy, control, and confidence.',
    date: 'Jul 2018',
    dateTime: '2018-07',
  },
  {
    name: 'First large-scale payroll customer onboarded',
    description:
      'Buddy began supporting payrolls at scale, validating the platform\'s robustness and suitability for complex, real-world payroll operations.',
    date: 'Jan 2020',
    dateTime: '2020-01',
  },
  {
    name: 'Expanded presence across international payroll events',
    description:
      'We engaged directly with payroll and accounting professionals across major industry events, shaping the platform based on real operational needs and industry feedback.',
    date: 'Sep 2022',
    dateTime: '2022-09',
  },
  {
    name: 'Officially recognised and operating in the UK payroll market',
    description:
      'After years of focused development and validation, Buddy became officially recognised and operational within the UK payroll ecosystem.',
    date: 'Nov 2023',
    dateTime: '2023-11',
  },
  {
    name: 'Expanded bureau-focused payroll capabilities',
    description:
      'Buddy introduced advanced workflows, approvals, and automation designed specifically for payroll bureaus managing multiple clients, entities, and approval chains at scale.',
    date: 'Jan 2024',
    dateTime: '2024-01',
  },
  {
    name: 'Signed a 60,000+ employee bureau partnership',
    description:
      'Buddy partnered with a large payroll bureau, reinforcing trust in the platform for high-volume, mission-critical payroll processing.',
    date: 'Aug 2024',
    dateTime: '2024-08',
  },
  {
    name: 'Enabled large-scale migrations from legacy payroll systems',
    description:
      'Buddy invested in automation and specialist tooling to help payroll teams migrate safely from legacy systems - reducing risk, manual effort, and disruption.',
    date: 'Sep 2024',
    dateTime: '2024-09',
  },
  {
    name: 'Hosted the Payroll Growth Summit (600+ attendees)',
    description:
      'Buddy brought together payroll professionals and industry experts for a three-day summit focused on scaling payroll operations, managing risk, and adopting modern payroll practices.',
    date: 'Feb 2025',
    dateTime: '2025-02',
  },
]
const jobOpenings = [
  {
    id: 1,
    role: 'Quality Assurance Engineer',
    // href: '#',
    // description:
    //   '',
    // salary: '€25,000',
    location: 'Malta / Hybrid',
    details: {
      reportsTo: 'QA Lead',
      location: 'Malta / Hybrid',
      summary:
        'The Quality Assurance Engineer plays a central role in ensuring the delivery of high-quality, secure, and reliable software across our engineering squads, covering both manual and automated testing.',
      responsibilities: [
        'Define and execute comprehensive test plans covering manual, automated, functional, and non-functional testing.',
        'Ensure testing covers requirements, acceptance criteria, security considerations, and architectural guidance.',
        'Conduct manual functional testing across web, API, microservices, and agent-based features.',
        'Perform exploratory testing to uncover defects related to logic, user flows, AI responses, or edge cases.',
        'Design, build, and maintain automated test suites for regression, integration, performance, and end-to-end testing.',
        'Develop test scripts using modern automation frameworks (Playwright, Cypress, Selenium, Postman/Newman, or API automation tools).',
        'Integrate automated tests into CI/CD pipelines in partnership with SRE and engineers.',
        'Implement automated validations for AI components such as output consistency checks and guardrail tests.',
        'Embed quality and testing considerations early in the SSDLC and participate in code reviews where applicable.',
        'Manage test data creation, anonymisation, and maintenance for manual and automated testing.',
        'Validate deployments in test and staging environments before production releases.',
        'Collaborate with Product Owners and the Scrum Master to ensure testing is integrated into sprints.',
        'Communicate quality risks, defect trends, and readiness assessments to stakeholders.',
      ],
      requirements: [
        'Practical experience in both manual and automated testing of modern web or cloud-native systems.',
        'Strong understanding of functional, regression, integration, exploratory, and performance testing.',
        'Hands-on experience with test automation frameworks (Playwright, Cypress, Selenium, REST API automation tools).',
        'Familiarity with CI/CD pipelines and integrating automated tests into deployment workflows.',
        'Experience testing APIs, microservices, and distributed systems.',
        'Awareness of secure coding, security testing basics, and data privacy considerations.',
        'Strong analytical and problem-solving skills with excellent attention to detail.',
        'Ability to work effectively within Agile squads and cross-functional environments.',
      ],
      whyJoinUs: [
        'You will help shape the future of quality engineering in an AI-enabled organisation.',
      ],
    },
  },
  {
    id: 2,
    role: 'Payroll Customer Support & Onboarding Advisor',
    location: 'Malta / Hybrid',
    details: {
      reportsTo: 'Customer Support Manager',
      salary: '€30,000 per annum',
      summary:
        'We are looking for a passionate Payroll Customer Support & Onboarding Advisor who loves solving problems, building relationships, and delivering exceptional service.',
      about: [
        'You will be the first point of contact for customers, guiding them through onboarding and providing ongoing support with our Payroll product.',
        'Your expertise will help ensure a seamless experience and drive continuous improvement.',
      ],
      responsibilities: [
        'Respond to customer queries via chat, case, and phone, aiming for first-contact resolution.',
        'Own the customer journey, ensuring a seamless experience from onboarding onwards.',
        'Guide new customers through system setup and configuration.',
        'Document processes and produce clear project plans with milestones.',
        'Identify and resolve issues, liaising with technical teams as needed.',
        'Share knowledge and create helpful resources for customers and colleagues.',
        'Deliver training sessions and attend customer service reviews.',
        'Stay up to date with product enhancements, technology trends, and payroll legislation.',
      ],
      requirements: [
        'An understanding of Malta payroll procedures (UK and Ireland experience is a plus).',
        'Experience in customer support, ideally within Software as a Service (SaaS).',
        'Excellent communication skills and ability to build strong relationships.',
        'Analytical thinker with a proactive approach to problem-solving.',
        'Ability to prioritise, meet deadlines, and work independently or as part of a team.',
      ],
      whyJoinUs: [
        'You will work in a collaborative, inclusive culture that values mental health, work-life balance, and equal opportunities.',
      ],
    },
  },
  {
    id: 3,
    role: 'Senior Engineer',
    location: 'Malta / Hybrid',
    details: {
      reportsTo: 'Engineering Manager',
      summary:
        'As the Senior Software Engineer (AI-First) you will design, build, and deliver AI-powered software systems, including autonomous agents and LLM-driven workflows, while mentoring engineers in emerging AI practices.',
      responsibilities: [
        'Design and build AI-driven services, agent architectures, and intelligent workflow orchestration components.',
        'Integrate LLMs, vector stores, embeddings, semantic search, and RAG patterns into production solutions.',
        'Develop autonomous or semi-autonomous agents capable of reasoning, planning, and secure tool use.',
        'Prototype, evaluate, and harden AI models, interaction patterns, and agent behaviours.',
        'Ensure AI components are robust, traceable, observable, and maintainable.',
        'Translate product requirements into technical designs and scalable implementation strategies.',
        'Provide technical mentorship, including prompt engineering techniques and development guidance.',
        'Lead design sessions on LLM integration, model constraints, safety guardrails, and multi-agent coordination.',
        'Champion high-quality coding practices, testing strategies, and secure-by-design principles.',
        'Embed AI safety, model validation, and guardrails into the development lifecycle.',
        'Apply secure-by-design principles including identity management, permission controls, and safe tool use.',
        'Conduct threat modelling and ensure compliance with regulatory and organisational standards.',
        'Build cloud-native services and integrate AI components with CI/CD pipelines and automated evaluation.',
        'Contribute to observability including prompt tracing, model performance monitoring, and agent state debugging.',
        'Work with the Lead SRE on scaling reliability and optimising platform performance and costs.',
        'Collaborate with Product Owners, Scrum Master, and stakeholders to communicate risks and trade-offs.',
      ],
      requirements: [
        'Experience as a senior engineer working with complex cloud-native systems.',
        'Hands-on expertise with LLMs, AI APIs, vector databases, pipelines, or agent frameworks.',
        'Deep understanding of backend or full-stack development with C# .NET, Node.js, React.js, Python, or equivalent.',
        'Solid grounding in secure coding practices, identity and access patterns, and safe AI interactions.',
        'Experience deploying AI-driven services into production with CI/CD and observability.',
        'Strong communication and mentoring ability, especially in emerging AI practices.',
        'Proven experience solving complex engineering challenges in an agile squad.',
      ],
      whyJoinUs: [
        'This role shapes how we embed AI into our platform and adopt AI-driven engineering across the organisation.',
      ],
    },
  },
]

const stats = [
  {
    label: "Colours",
    value: 3
  },
  {
    label: "Pieces",
    value: 9
  },
  {
    label: "Team Members",
    value: 12
  },
  {
    label: "Figolli",
    value: 100
  },
]

const figolliHighlights = [
  {
    name: 'The Assembly Line',
    description: [
      'Putting together these Figolli meant each piece being hand-cut, segregated from the sugar paste sheets, and carefully placed onto the underlying figolla base.',
      'Each figolla passed through a quality control process, where details, such as the positioning of the eyes were thourhly check to ensure they were up to standard.',
      "It's also fair to say, that quite a few vanished throughout the quality control process...",
    ],
    imageSrc: 'https://player.vimeo.com/video/824412163?h=a2f11aefbf&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
  },
  {
    name: 'Finishing Touches',
    description:[
      'Once the Figolli were all complete, they had to undergo one final process.',
      'Cleaning and removing of any excess sugar paste, that appeared through the cutting of the fine details. Including any minor adjustments by hand.',
      'Finally, they were individually packaged with a personalised signature from the team member who sealed the final package.',
      "If you're lucky you'll be able to get some signed by our co-Founders David and Jonathan, which are guaranteed to be collectables.",
    ],
    imageSrc: 'https://player.vimeo.com/video/824412905?h=d67ef27c43&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    imageAlt: 'Detail of zipper pull with tan leather and silver rivet.',
  },
]


const people = [
  {
    name: 'Chris Deeson',
    role: 'COO of LitE Consulting Ltd',
    imageUrl: testimonialPhoto,
    bio: "Didn't last long once I got it back home!",
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Roderick Schneider',
    role: 'COO of Workforce.com',
    imageUrl: testimonialPhoto2,
    bio: "I only got to take the photo! The team left no traces by the time I got back to the office.",
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  // More people...
]

const values = [
    {
        name: "Growth mindset",
        description: "We continuously improve as individuals, as a team, and as a platform.",
    },
    {
        name: "Share the knowledge",
        description: "We believe better-informed payroll teams make better decisions.",
    },
    {
        name: "Carry your own bag",
        description: "We take ownership and responsibility for our work and its impact.",
    },
    {
        name: "Team first",
        description: "We act with respect and collaboration, internally and with our customers.",
    },
    {
        name: "The right way",
        description: "We operate ethically, transparently, and with long-term responsibility.",
    },
]
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function Figolli({
  addTag
}) {

  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [selectedOpening, setSelectedOpening] = useState(null);

  const closeOpeningModal = () => setSelectedOpening(null);

  return (

    <React.Fragment>
      
        <SeoHeaders
            title={`Buddy - The Story | About Buddy | Who is behind Buddy HR `}
            description={"Discover the people and mission behind Buddy. The a Leading Payroll Software in the UK and Malta."}
        />

        <main className="isolate bg-white">
            {/* Hero section */}
            <div className="relative isolate -z-10 overflow-hidden bg-gradient-to-b from-orange-100/20 pt-14">
              <div
                className="absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-white shadow-xl shadow-orange-600/10 ring-1 ring-orange-50 sm:-mr-80 lg:-mr-96"
                aria-hidden="true"
              />
              <div className="mx-auto max-w-7xl px-6 py-32 sm:py-40 lg:px-8">
                <div className="mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8">
                  <h1 className="max-w-2xl text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl lg:col-span-2 xl:col-auto">
                    Built for the people behind payroll
                  </h1>
                  <div className="mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1">
                    <p className="text-lg leading-8 text-gray-600 mb-2">
                      Buddy is a modern payroll platform designed for teams who take payroll seriously. We combine powerful technology with real human expertise to help businesses run payroll accurately, confidently, and at scale.
                    </p>
                    <p className="text-lg leading-8 text-gray-600 mb-2">
                      Used by growing payroll teams across the UK and beyond, Buddy supports organisations where payroll is not just a task - it is a responsibility.
                    </p>
                    <p className="text-lg leading-8 text-gray-600 mb-2">
                      Built for the people behind payroll, Buddy combines modern, scalable technology with deep payroll expertise and a long-term commitment to the businesses that rely on us.
                    </p>
                  </div>
                  <img
                    src={budgetTeamPhoto}
                    alt=""
                    className="mt-10 aspect-[6/5] w-full max-w-lg rounded-2xl object-cover sm:mt-16 lg:mt-0 lg:max-w-none xl:row-span-2 xl:row-end-2 xl:mt-36"
                  />
                </div>
              </div>
              <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
            </div>

            {/* Timeline section */}
            <div className="mx-auto -mt-8 max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
                <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our journey so far</h2>
                <p className="mt-6 text-base leading-7 text-gray-600">
                  Founded with a clear mission, Buddy has grown alongside the payroll teams we serve, supporting increasingly complex, high-volume payroll operations.
                </p>
              </div>
              <div className="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-8 overflow-hidden lg:mx-0 lg:max-w-none lg:grid-cols-4">
                {timeline.map((item) => (
                  <div key={item.name}>
                    <time
                      dateTime={item.dateTime}
                      className="flex items-center text-sm font-semibold leading-6 text-orange-600"
                    >
                      <svg viewBox="0 0 4 4" className="mr-4 h-1 w-1 flex-none" aria-hidden="true">
                        <circle cx={2} cy={2} r={2} fill="currentColor" />
                      </svg>
                      {item.date}
                      <div
                        className="absolute -ml-2 h-px w-screen -translate-x-full bg-gray-900/10 sm:-ml-4 lg:static lg:-mr-6 lg:ml-8 lg:w-auto lg:flex-auto lg:translate-x-0"
                        aria-hidden="true"
                      />
                    </time>
                    <p className="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{item.name}</p>
                    <p className="mt-1 text-base leading-7 text-gray-600">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Logo cloud */}
            {/*<div className="mx-auto mt-32 max-w-7xl sm:mt-40 sm:px-6 lg:px-8">
              <div className="relative isolate overflow-hidden bg-gray-900 px-6 py-24 text-center shadow-2xl sm:rounded-3xl sm:px-16">
                <h2 className="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
                  Our customers love us
                </h2>
                <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-300">
                  Aliquip reprehenderit incididunt amet quis fugiat ut velit. Sit occaecat labore proident cillum in nisi
                  adipisicing officia excepteur tempor deserunt.
                </p>
                <div className="mx-auto mt-20 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-12 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 sm:gap-y-14 lg:max-w-4xl lg:grid-cols-5">
                  <img
                    className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                    src="https://tailwindui.com/img/logos/158x48/transistor-logo-white.svg"
                    alt="Transistor"
                    width={158}
                    height={48}
                  />
                  <img
                    className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                    src="https://tailwindui.com/img/logos/158x48/reform-logo-white.svg"
                    alt="Reform"
                    width={158}
                    height={48}
                  />
                  <img
                    className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                    src="https://tailwindui.com/img/logos/158x48/tuple-logo-white.svg"
                    alt="Tuple"
                    width={158}
                    height={48}
                  />
                  <img
                    className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
                    src="https://tailwindui.com/img/logos/158x48/savvycal-logo-white.svg"
                    alt="SavvyCal"
                    width={158}
                    height={48}
                  />
                  <img
                    className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
                    src="https://tailwindui.com/img/logos/158x48/statamic-logo-white.svg"
                    alt="Statamic"
                    width={158}
                    height={48}
                  />
                </div>
                <div className="absolute -top-24 right-0 -z-10 transform-gpu blur-3xl" aria-hidden="true">
                  <div
                    className="aspect-[1404/767] w-[87.75rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-25"
                    style={{
                      clipPath:
                        'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)',
                    }}
                  />
                </div>
              </div>
            </div>
*/}
            {/* Content section */}
            <div className="mt-32 overflow-hidden sm:mt-40">
              <div className="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8">
                  <div className="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Why Buddy exists</h2>
                    <p className="mt-6 text-xl leading-8 text-gray-600">
                      Payroll is one of the most critical systems in any business and one of the least forgiving when things go wrong.
                    </p>
                    <p className="mt-6 text-base leading-7 text-gray-600">
                      At Buddy, we believe payroll software should reflect that reality. Our focus is simple: help payroll teams pay people correctly, compliantly, and on time every time.
                    </p>
                    <p className="mt-6 text-base leading-7 text-gray-600">
                      We do this by combining modern, scalable technology with deep payroll expertise and a long-term commitment to the businesses that rely on us.
                    </p>
                    <h3 className="mt-10 text-2xl font-bold tracking-tight text-gray-900">Payroll expertise you can rely on</h3>
                    <p className="mt-6 text-base leading-7 text-gray-600">
                      Behind Buddy is a multidisciplinary team of payroll specialists, engineers, and support professionals who understand the responsibility that comes with running payroll. Every Buddy customer has access to real people who understand payroll and compliance, know the platform inside out, and are accountable for getting things right. We do not hide behind software - we stand behind it.
                    </p>
                  </div>
                  <div className="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
                    <div className="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
                      <img
                        src={sicilyOutdoorsPhoto}
                        alt=""
                        className="aspect-[7/5] w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                      />
                    </div>
                    <div className="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8">
                      <div className="order-first flex w-64 flex-none justify-end self-end lg:w-auto">
                        <img
                          src={gamesNightPhoto}
                          alt=""
                          className="aspect-[4/3] w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                        />
                      </div>
                      <div className="flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                        <img
                          src={sicilyLunchPhoto}
                          alt=""
                          className="aspect-[7/5] w-[37rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                        />
                      </div>
                      <div className="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                        <img
                          src={keelanSleepingPhoto}
                          alt=""
                          className="aspect-[4/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Values */}
            <div className="bg-white py-24 sm:py-32">
              <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                  <div>
                    <h2 className="text-base font-semibold leading-7 text-orange-600">Value-Driven</h2>
                    <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our values</p>
                    <p className="mt-6 text-base leading-7 text-gray-600">
                      Our values guide how we build, support, and partner with our customers, shaping decisions, interactions, and outcomes.
                    </p>
                  </div>
                  <dl className="col-span-2 grid grid-cols-1 gap-x-8 gap-y-10 text-base leading-7 text-gray-600 sm:grid-cols-2">
                    {values.map((value) => (
                      <div key={value.name} className="relative pl-9">
                        <dt className="font-semibold text-gray-900">
                          <CheckIcon className="absolute left-0 top-1 h-5 w-5 text-orange-500" aria-hidden="true" />
                          {value.name}
                        </dt>
                        <dd className="mt-2">{value.description}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="mx-auto mt-2 max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-2xl lg:mx-0">
                <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our impact</h2>
                <p className="mt-6 text-base leading-7 text-gray-600">
                  These numbers reflect the scale and responsibility our customers trust us with every day.
                </p>
              </div>
              <div className="mx-auto mt-16 flex max-w-2xl flex-col gap-8 lg:mx-0 lg:mt-20 lg:max-w-none lg:flex-row lg:items-end">
                <div className="flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-gray-50 p-8 sm:w-3/4 sm:max-w-md sm:flex-row-reverse sm:items-end lg:w-72 lg:max-w-none lg:flex-none lg:flex-col lg:items-start">
                  <p className="flex-none text-3xl font-bold tracking-tight text-gray-900">235,000+</p>
                  <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
                    <p className="text-lg font-semibold tracking-tight text-gray-900">Payroll calculations in 24 hours</p>
                    <p className="mt-2 text-base leading-7 text-gray-600">
                      Supporting businesses and their employees, consistently and reliably.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-gray-900 p-8 sm:flex-row-reverse sm:items-end lg:w-full lg:max-w-sm lg:flex-auto lg:flex-col lg:items-start lg:gap-y-44">
                  <p className="flex-none text-3xl font-bold tracking-tight text-white">€108 million</p>
                  <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
                    <p className="text-lg font-semibold tracking-tight text-white">€108+ million processed annually</p>
                    <p className="mt-2 text-base leading-7 text-gray-400">
                      Representing basic salaries processed through Buddy, excluding bonuses, overtime, and other benefits.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-orange-600 p-8 sm:w-11/12 sm:max-w-xl sm:flex-row-reverse sm:items-end lg:w-full lg:max-w-none lg:flex-auto lg:flex-col lg:items-start lg:gap-y-28">
                  <p className="flex-none text-3xl font-bold tracking-tight text-white">429,000+</p>
                  <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
                    <p className="text-lg font-semibold tracking-tight text-white">Leave applications managed</p>
                    <p className="mt-2 text-base leading-7 text-orange-200">
                        Helping employees take time off with confidence through simple, compliant workflows.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Content section */}
            <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8 pb-10">
              <div className="mx-auto flex max-w-2xl flex-col items-end justify-between gap-16 lg:mx-0 lg:max-w-none lg:flex-row">
                <div className="w-full lg:max-w-lg lg:flex-auto">
                  <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    A payroll partner you can depend on
                  </h2>
                  <p className="mt-6 text-xl leading-8 text-gray-600">
                    Payroll is not something businesses can afford to get wrong. Buddy is built to be a long-term partner, combining robust technology, expert support, and the backing required to serve customers reliably for years to come.
                    Whether you are running payroll in-house, supporting clients as a bureau, or scaling across multiple entities, Buddy is designed to grow with you without compromise.
                  </p>
                  <h3 className="mt-10 text-2xl font-bold tracking-tight text-gray-900">Building for the long term</h3>
                  <p className="mt-6 text-base leading-7 text-gray-600">
                    As Buddy continues to grow, we hire carefully and deliberately, looking for people who care deeply about quality, accountability, and customer outcomes.
                    We are building a team focused on long-term impact, not short-term hype.
                  </p>
                  <img
                    src={teamDevelopers}
                    alt=""
                    className="mt-16 aspect-[6/5] w-full rounded-2xl bg-gray-50 object-cover lg:aspect-auto lg:h-[34.5rem]"
                  />
                </div>
                <div className="w-full lg:max-w-xl lg:flex-auto">
                  <h3 className="sr-only">Job openings</h3>
                  <ul className="space-y-4">
                    {jobOpenings.map((opening) => (
                      <li key={opening.id} className="rounded-2xl border border-gray-100 bg-gray-50 p-4 shadow-sm transition hover:border-orange-200 hover:shadow-md">
                        <dl className="relative">
                          <dt className="sr-only">Role</dt>
                          <dd>
                            <button
                              type="button"
                              className="group flex w-full items-start justify-between gap-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
                              onClick={() => setSelectedOpening(opening)}
                            >
                              <div>
                                <p className="text-lg font-semibold tracking-tight text-gray-900 transition group-hover:text-orange-600">
                                  {opening.role}
                                </p>
                                <p className="mt-2 flex items-center gap-x-2 text-sm leading-6 text-gray-500">
                                  <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 flex-none fill-gray-300" aria-hidden="true">
                                    <circle cx={1} cy={1} r={1} />
                                  </svg>
                                  {opening.location}
                                </p>
                                <p className="mt-3 text-sm font-semibold text-orange-600">View details</p>
                              </div>
                              <ChevronRightIcon className="h-5 w-5 text-gray-300" aria-hidden="true" />
                            </button>
                          </dd>
                          <dt className="sr-only">Description</dt>
                          {opening.description ? (
                            <dd className="mt-4 text-base leading-7 text-gray-600">{opening.description}</dd>
                          ) : null}
                          <dt className="sr-only">Salary</dt>
                          {opening.salary ? (
                            <dd className="mt-4 text-base font-semibold leading-7 text-gray-900">{opening.salary}</dd>
                          ) : null}
                        </dl>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-4 flex border-t border-gray-100 pt-6">
                    <a href="mailto:join@buddy.hr" className="text-sm font-semibold leading-6 text-orange-600 hover:text-orange-500">
                      Looking to Join us? <span aria-hidden="true">&rarr;</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {selectedOpening ? (
              <div className="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div className="fixed inset-0 bg-gray-900/60 transition-opacity" onClick={closeOpeningModal} />
                <div className="fixed inset-0 z-50 overflow-y-auto">
                  <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-6">
                    <div className="relative w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white p-6 text-left shadow-xl transition-all sm:p-8">
                      <div className="flex items-start justify-between gap-6">
                        <div>
                          <h3 className="text-2xl font-bold tracking-tight text-gray-900" id="modal-title">
                            {selectedOpening.role}
                          </h3>
                          <p className="mt-2 text-sm text-gray-500">{selectedOpening.location}</p>
                        </div>
                        <button
                          type="button"
                          className="rounded-md p-2 text-gray-400 hover:text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
                          onClick={closeOpeningModal}
                        >
                          <span className="sr-only">Close</span>
                          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>

                      {selectedOpening.details?.reportsTo ? (
                        <p className="mt-4 text-sm text-gray-600">
                          <span className="font-semibold text-gray-900">Reports to:</span> {selectedOpening.details.reportsTo}
                        </p>
                      ) : null}
                      {selectedOpening.details?.salary ? (
                        <p className="mt-2 text-sm text-gray-600">
                          <span className="font-semibold text-gray-900">Salary:</span> {selectedOpening.details.salary}
                        </p>
                      ) : null}

                      {selectedOpening.details?.summary ? (
                        <p className="mt-6 text-base leading-7 text-gray-700">
                          {selectedOpening.details.summary}
                        </p>
                      ) : null}

                      {selectedOpening.details?.about ? (
                        <div className="mt-6">
                          <h4 className="text-lg font-semibold text-gray-900">About the role</h4>
                          <div className="mt-3 space-y-2 text-base leading-7 text-gray-600">
                            {selectedOpening.details.about.map((item) => (
                              <p key={item}>{item}</p>
                            ))}
                          </div>
                        </div>
                      ) : null}

                      {selectedOpening.details?.responsibilities ? (
                        <div className="mt-6">
                          <h4 className="text-lg font-semibold text-gray-900">What you'll do</h4>
                          <ul className="mt-3 list-disc space-y-2 pl-6 text-base leading-7 text-gray-600">
                            {selectedOpening.details.responsibilities.map((item) => (
                              <li key={item}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      ) : null}

                      {selectedOpening.details?.requirements ? (
                        <div className="mt-6">
                          <h4 className="text-lg font-semibold text-gray-900">What we're looking for</h4>
                          <ul className="mt-3 list-disc space-y-2 pl-6 text-base leading-7 text-gray-600">
                            {selectedOpening.details.requirements.map((item) => (
                              <li key={item}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      ) : null}

                      {selectedOpening.details?.whyJoinUs ? (
                        <div className="mt-6">
                          <h4 className="text-lg font-semibold text-gray-900">Why join us</h4>
                          <ul className="mt-3 list-disc space-y-2 pl-6 text-base leading-7 text-gray-600">
                            {selectedOpening.details.whyJoinUs.map((item) => (
                              <li key={item}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      ) : null}

                      <div className="mt-8">
                        <a
                          href={`mailto:${selectedOpening.details?.email || 'join@buddy.hr'}`}
                          className="text-sm font-semibold leading-6 text-orange-600 hover:text-orange-500"
                        >
                          Interested in this role? <span aria-hidden="true">&rarr;</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
       </main>

    </React.Fragment>

  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),

  addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Figolli)
